/*                      */

export default class Logger {
	static group(title) {
		if (window.o_global.debug.status().enabled) {
			if (console.group) console.group(title);
		}
	}

	static groupEnd() {
		if (window.o_global.debug.status().enabled) {
			if (console.groupEnd) console.groupEnd();
		}
	}

	static log(msg) {
		if (window.o_global.debug.status().enabled) {
			console.log(msg);
		}
	}

	static table(table) {
		if (window.o_global.debug.status().enabled) {
			if (console.table) console.table(table);
		}
	}

	static count(label) {
		if (window.o_global.debug.status().enabled) {
			if (console.count) console.count(label);
		}
	}
}
